import { Card, CardContent, makeStyles, Theme } from '@material-ui/core'
import { blue, green, orange, pink, purple, red, yellow } from '@material-ui/core/colors'
import React from 'react'
import { ROMAN_DEGREES } from '../../util/constants'
import ChordEl from '../ChordEl'

const degreesColors = [
  red[300],
  orange[300],
  yellow[300],
  green[300],
  blue[300],
  purple[300],
  pink[300],
]

type Props = {
  degreeColor: string,
  selected?: boolean,
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  card: {
		borderTop: ({ degreeColor }) => '5px solid ' + degreeColor,
    borderBottom: ({ degreeColor }) => '5px solid ' + degreeColor,
    backgroundColor: ({ selected }) => selected ? '#4c4e50' : '#3a3c3e',
    width: 64,
    marginRight: 8,
    display: 'flex',
    transition: 'background-color ease 0.25s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: ({ selected }) => selected !== undefined ? undefined : '#4c4e50',
    },
  },
  cardTiny: {
		borderTop: ({ degreeColor }) => '3px solid ' + degreeColor,
    borderBottom: ({ degreeColor }) => '3px solid ' + degreeColor,
    backgroundColor: ({ selected }) => selected ? '#4c4e50' : '#3a3c3e',
    width: 32,
    marginRight: 0,
    display: 'flex',
    transition: 'background-color ease 0.25s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: ({ selected }) => selected !== undefined ? undefined : '#4c4e50',
    },
    borderRadius: 0,
  },
  cardContent: {
    padding: 8,
    paddingBottom: '8px !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
  cardContentTiny: {
    padding: 4,
    paddingBottom: '4px !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
}))

const EditorSmallChordCard = (props: {
  chord: any,
  onClick?: (chord: any) => void,
  tiny?: boolean,
  selected?: boolean,
}) => {

  const {
    chord,
    onClick = () => null,
    tiny = false,
    selected,
  } = props

  const classes = useStyles({
    degreeColor: degreesColors[ROMAN_DEGREES.findIndex((d: string) => d === chord.degreeName.split(' ')[0].toUpperCase())],
    selected,
  })

  return (
    <Card className={tiny ? classes.cardTiny : classes.card} onClick={() => onClick(chord)}>
      <CardContent className={tiny ? classes.cardContentTiny : classes.cardContent}>
        <ChordEl
          chord={chord}
          tiny={tiny}
          isDegree
        />
      </CardContent>
    </Card>
  )
}

export default EditorSmallChordCard
